import { get, post, getAuthHeaders, handleResponse, delay } from './helpers';
import { APP2_URL } from '../mainurl';

const getUserDataUrl = `${APP2_URL}getUserData`;

export function getUserData({useLocalStorageAccessToken = false} = {}) {
  return get(getUserDataUrl, getAuthHeaders({useLocalStorageAccessToken}))
    .then(handleResponse);
}
